import { render, staticRenderFns } from "./DefaultLayoutSidebarItems.vue?vue&type=template&id=a146b14c&scoped=true&"
import script from "./DefaultLayoutSidebarItems.vue?vue&type=script&lang=ts&"
export * from "./DefaultLayoutSidebarItems.vue?vue&type=script&lang=ts&"
import style0 from "./DefaultLayoutSidebarItems.vue?vue&type=style&index=0&id=a146b14c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a146b14c",
  null
  
)

export default component.exports